import React from 'react';

import {AuthContext} from "../../authContext";
import Button from "../shared/Button";
import CitySearchResults from "../shared/CitySearchResults";
import FormContainer from "../shared/form/FormContainer";
import FormLabel from "../shared/form/FormLabel";
import {getCities} from "../data/data";
// import getIsUKPostcode from "../shared/utilities/getIsUKPostcode";
import Loading from "../shared/Loading";
import TextInput from "../shared/form/TextInput";
import FormControl from "../shared/form/FormControl";
import setLocation from "../shared/utilities/setLocation";
import Flex from "../shared/Flex";
import WebLink from "../shared/WebLink";

class ModelLocation extends React.Component {
  static contextType = AuthContext;
  state = {
    cities: [],
    isSearching: false,
    isShowManualLocationEntry: false,
    isSearchingPostcode: false,
    searchTerms: "",
    latitude: "",
    longitude: ""
  };
  componentDidMount = async () => {
    //console.log("Model location component mounted")
  };
  clearSearchResults = async() => {
    await this.setState({cities: []});
  };
  handleFormUpdate = async e => {

    // let string = e.currentTarget;

    // console.log("handleFormUpdate",string);

    // if (getIsUKPostcode(string))
    //   await this.setState({isSearchingPostcode: true});
    // else
    //   await this.setState({isSearchingPostcode: false});

    // console.log("Updating form id ", e.currentTarget.id, string);
    // console.log("Is postcode: ", getIsUKPostcode(e.currentTarget.value));

    let a = {}; a[e.currentTarget.id] = e.currentTarget.value;
    await this.setState(a);
  };

  isValidLatitude = (lat) => {
    return !(isNaN(lat) || lat > 90 || lat < -90 || lat === "" || lat === "-");
  };
  isValidLongitude = (lng) => {
    return !(isNaN(lng) || lng < -180 || lng > 180 || lng === "" || lng === "-");
  };
  search = async () => {
    if (this.state.searchTerms === "" || this.state.searchTerms.length < 2)
      return null;
    await this.setState({isSearching: true});
    const cities = await getCities(this.state.searchTerms);

    await this.setState({
      cities: cities.data,
      isSearching: false
    });

    if (cities.data.length < 1) {
      let notification = {
        id: Math.random(),
        title: "No results found",
        body: "Please search for a place name from anywhere in the world.",
        isAlert: true
      };
      this.context.addNotification(notification);
    }

    //console.log("cities", cities);
  };
  toggleManualLocationSearch = async () => {
    this.setState({isShowManualLocationEntry: !this.state.isShowManualLocationEntry});
  };
  updateLocation = async (lat, lng) => {
    if (this.isValidLatitude(lat) && this.isValidLongitude(lng)) {
      setLocation(lat, lng);
    }
    else {
      let notification = {
        id: Math.random(),
        title: "Invalid location",
        body: "Latitude must be a number in the range -90 to 90 and longitude must be a number in the range -180 to 180",
        isAlert: true
      };
      this.context.addNotification(notification);
    }
  };
  render() {
    return (
      <div>
        <h3>Set Model Location</h3>
        <p>You can set the geographic coordinates of the centre of your CityCAD model here.</p>
        <div>
          <Flex>
            <TextInput
              id={`searchTerms`}
              value={this.state.searchTerms}
              placeholder={`Search for a placename...`}
              onChange={this.handleFormUpdate}
              type="text"
              autoComplete={"off"}
              style={{flexGrow:"flex-grow"}}
            />
            <Button style={{marginLeft: "10px"}} onClick={this.search}>
              Search
            </Button>
          </Flex>
        </div>
        {
          this.state.isSearching && <Loading />
        }
        {
          this.state.cities.length > 0
          &&
          <CitySearchResults
            cities={this.state.cities}
            updateLocation={this.updateLocation}
          />
        }
        {
          this.state.cities.length > 0
          &&
          <div style={{textAlign: "center", marginTop: "10px"}}>
            <WebLink onClick={this.clearSearchResults}>Clear search results</WebLink>
          </div>
        }
        <div style={{marginTop:"15px", cursor:"pointer", textAlign: "center"}} onClick={this.toggleManualLocationSearch}>
          <WebLink>Enter specific latitude/longitude</WebLink>
        </div>
        {
          this.state.isShowManualLocationEntry
          &&
          <FormContainer>
            <p>Specify a geographic location in WGS84 latitude/longitude coordinates</p>
            {
              this.state.isSearchingPostcode
              &&
              <p>Search for UK postcode</p>
            }
            {
              (!this.isValidLatitude(this.state.latitude) && this.state.latitude !== "" && this.state.latitude !== "-")
              &&
              <p style={{color: "red"}}>Latitude must be a number in the range -90 to 90</p>
            }
            {
              (!this.isValidLatitude(this.state.longitude) && this.state.longitude !== "" && this.state.longitude !== "-")
              &&
              <p style={{color: "red"}}>Longitude must be a number in the range -180 to 180</p>
            }
            <FormControl horizontal>
              <FormLabel>Latitude</FormLabel>
              <TextInput
                id={`latitude`}
                value={this.state.latitude}
                onChange={this.handleFormUpdate}
                type="text"
                autoComplete={"off"}
              />
            </FormControl>
            <FormControl horizontal>
              <FormLabel>Longitude</FormLabel>
              <TextInput
                id={`longitude`}
                value={this.state.longitude}
                onChange={this.handleFormUpdate}
                type="text"
                autoComplete={"off"}
              />
            </FormControl>
            <div style={{textAlign:"right", marginTop: "10px"}}>
              <Button onClick={() => this.updateLocation(this.state.latitude, this.state.longitude)}>Update model location now</Button>
            </div>
          </FormContainer>
        }
      </div>
    )
  }
}

export default ModelLocation;
